
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/cocktails-for-cause-2024",
      function () {
        return require("private-next-pages/events/cocktails-for-cause-2024.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/cocktails-for-cause-2024"])
      });
    }
  